import styled from 'styled-components';

import { Typography } from '../../shared/typography';

const Bottom = styled.div`
	flex: 5;
	display: flex;
	flex-direction: column;
	align-items: center;

	@media (max-width: 1024px) {
		flex: initial;
	}
`;

const Header = styled.div`
	max-width: 300px;
	margin-bottom: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const WrapTitle = styled.div`
	max-width: 360px;
	margin-bottom: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const Content = styled.div`
	height: 100%;
	width: 480px;
	max-width: 480px;
	min-width: 200px;
	padding: 0 20px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;

	@media (max-width: 1024px) {
		width: 100vw;
		min-width: 200px;
	}
`;

const Title = styled(Typography)`
	font-size: 24px;
	line-height: 30px;
`;

const Separator = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 50px 0;

	@media (max-width: 1024px) {
		margin: 40px 0;
	}
`;

const Line = styled.div`
	flex: 3;
	height: 1px;
	background-color: ${p => p.theme.colors.btnTextGrey};
`;

const SeparatorText = styled(Typography)`
	flex: 1;
	text-align: center;
`;

const Center = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	margin-bottom: 25px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Bottom,
	WrapTitle,
	Header,
	Content,
	Title,
	Separator,
	Line,
	SeparatorText,
	Center,
};
